import { Brand } from './interfaces/brand';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api';

@Injectable({ providedIn: 'root' })
export class BrandsService {

  path: string = '/api';

  constructor(private apiService: ApiService) { }

  setBrands(partnerId: number, brands: Brand[]) {
    return this.apiService
      .put(`${this.path}/airlines/${partnerId}`, {
        data: {
          brands,
        },
      });
  }

  getAll(partnerId: number): Observable<Brand[]> {
    return this.apiService.get<Brand[]>(`${this.path}/v2/airlines/${partnerId}/brands`);
  }

  delete(partnerId: number, brandId: number) {
    return this.apiService
      .delete(`${this.path}/v2/airlines/${partnerId}/brands/${brandId}`);
  }

  create(partnerId: number, brands: Brand[]): Observable<Brand[]> {
    return this.apiService
      .post<Brand[]>(`${this.path}/v2/airlines/${partnerId}/brands`, { brands });
  }

  updateMultiple(partnerId: number, brands: Brand[]): Observable<Brand[]> {
    return this.apiService
      .put<Brand[]>(`${this.path}/v2/airlines/${partnerId}/brands`, { brands });
  }

  assignPosition(brands: Brand[]): Brand[] {
    brands.forEach((brand) => {

      if (!brand.position) {
        brand.position = Math.max(...brands
          .filter(brand => !!brand.position)
          .map(brand => brand.position ?? 0)
        ) + 1
      }

      if (brand.codes) {
        brand.code = Array.isArray(brand.codes) ? brand.codes.join(', ') : brand.codes;
      }

    });

    // Every brand.position is set by the forEach above (pre-existing or freshly assigned).
    return brands.sort((a, b) => a.position! - b.position!);
  }

}

